export const AI_SKILLS_LABEL = 'AI Skills';
export const TINYMCE_KEY = '4p7xzl6cgv6yepmk4r0u2hhdx7k8nm1m481jccjs6d0si63z';
